import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const professionalIntegratorsRoutes = {
  [ERouteMappingKeys.PROFESSIONAL_INTEGRATORS]: {
    id: "professional-integrators",
    path: "/professional-integrators",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/ProfessionalIntegrators").then((p) => ({
          default: p.ProfessionalIntegrators,
        })),
      ),
    },
  },
};
